app.service("MethodInputService", ['$rootScope', function ($rootScope) {

    const service = this;

    const siteHelper = $rootScope.site_helper;
    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const MethodInputModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Method Input",
        id: "method_input",
        navigation_pointer: "method_input_id",
        choice_order: ['property', 'filter']
    });

    this.factory = new modelConstructor.RouteFactory({

        choices: {
            property: new RouteChoice({
                name: "By Property"
            }),
            filter: new RouteChoice({
                public_id: "criteria",
                name: "By Criteria",
                breadcrumb_name: "Criteria"
            })
        },

        birth: function (values) {
            return new MethodInputModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const choiceOrder = model.choice_order;
        const browseID = variationIDs.browse_id;
        const siteRangeID = variationIDs.site_range_id;
        const componentID = variationIDs.component_id;
        const hideWith = browseID !== "component" ? ["component"] : ["collection_product", "individual_product"];
        let nextModelID;
        let cacheStateIDs = null;
        if (browseID === "component") {
            let baseComponentID = null;
            let parentCategoryID = null;
            switch (componentID) {
                case "stock_panel":
                    baseComponentID = "stock";
                    parentCategoryID = "panel";
                    break;
                case "stock_plinth":
                    baseComponentID = "stock";
                    parentCategoryID = "plinth";
                    break;
                case "stock_curved":
                    baseComponentID = "stock";
                    parentCategoryID = "curved";
                    break;
                default:
                    break;
            }
            if (baseComponentID) {
                const fromChoiceOrder = parentCategoryID ? [parentCategoryID] : null;
                const fromChoiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList(baseComponentID, fromChoiceOrder);
                cacheStateIDs = fromChoiceList.length ? fromChoiceList[0].state_ids : null;
            }
            nextModelID = !cacheStateIDs ? "tile" : "site_range";
        } else if (browseID === "site_range") {
            nextModelID = "colour_route";
        } else {
            nextModelID = "door_type";
        }

        model.default_choice_id = choiceOrder[0];

        const choices = siteHelper.cloneChoices(service.factory.choices, choiceOrder);
        for (let choiceID in choices) {
            const choice = choices[choiceID];
            if (cacheStateIDs) {
                siteHelper.simpleCloneObject(cacheStateIDs, choice.state_ids);
            }
        }
        const propertyChoice = choices.property;
        if (propertyChoice) {
            if (browseID === "component") {
                propertyChoice.public_id = "product";
                propertyChoice.name = "By Product";
                propertyChoice.breadcrumb_name = "Product";
            } else if (browseID === "site_range") {
                propertyChoice.public_id = "colour";
                if (siteRangeID === "bella") {
                    propertyChoice.name = "By Colour & Style";
                } else {
                    propertyChoice.name = "By Colour";
                }
                propertyChoice.breadcrumb_name = "Colour";
            } else {
                propertyChoice.public_id = "range";
                propertyChoice.name = "By Range";
                propertyChoice.breadcrumb_name = "Range";
            }
        }

        siteHelper.applyValues(model, {
            choice_order: choiceOrder,
            choices: choices,
            next_model_id: nextModelID,
            hide_with: hideWith
        });
    }
}])